<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="6"
            categoryName="Pump"
            categorySectionIcon="fa-wrench"
            :useSearch1="true"
            search1Title="Stages"
            :useSearch2="true"
            search2Title="Spec"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'pump',
    components: { BaseInventory }
}
</script>
